var _style, _defs, _mask, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrow1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "katman_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 600 450",
    style: {
      enableBackground: "new 0 0 600 450"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#010202;filter:url(#Adobe_OpacityMaskFilter);stroke:#FFFFFF;stroke-width:19.0518;stroke-miterlimit:3.964;}\r\n\t.st1{mask:url(#mask-path-0.714075822092155_00000159444839320873470970000012753669590367924401_);}\r\n\t.st2{fill:#010202;}\r\n")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Adobe_OpacityMaskFilter",
    filterUnits: "userSpaceOnUse",
    x: 165.9,
    y: 182,
    width: 268.5,
    height: 86.9
  }, /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "1 0 0 0 0  0 1 0 0 0  0 0 1 0 0  0 0 0 1 0"
  })))), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    maskUnits: "userSpaceOnUse",
    x: 165.9,
    y: 182,
    width: 268.5,
    height: 86.9,
    id: "mask-path-0.714075822092155_00000159444839320873470970000012753669590367924401_"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M433.1,251.8c-87.6,34.3-201.9-6.4-260.4-64.8l0,0l47,3.8l-47-3.8l30.5,61"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "st1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M434,253.2c0.6,0,0.3-1,0.3-1.2C433.3,252.3,434,253.5,434,253.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M424.3,257l0.1-0.4l-1.3,1.3L424.3,257z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M414.9,258.4c1.1,1.7,3.4-0.8,5.1-0.4l0.3,0.4l0.6-1.5C418.9,257.3,416.4,258.6,414.9,258.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M409.4,255.2c0.4,0.7-1,0.8,1.2,0c-0.1,0-0.2-0.1-0.2-0.2C410,255.1,409.7,255.2,409.4,255.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M410.3,255.1C411.3,254.9,409.6,254.6,410.3,255.1L410.3,255.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M405.9,256.2l1.2-0.8c-0.3-0.4-1.5-0.3-1.1-0.7C404.7,255.2,405,255.6,405.9,256.2L405.9,256.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M404.8,257.6l0.6-0.4C405.3,257.1,405.1,257.1,404.8,257.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M406.8,256.5l-1.3,0.7c0.2,0.3,0.3,0.9,0.6-0.3C406.1,257.6,406.3,257,406.8,256.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M407.7,256.7c0.8,0.3,1.8,0.4,0.5,1.2C410.6,257.3,410.1,256,407.7,256.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M414.7,260.3l1.1,0.4l0.8-0.7C416.2,260.3,414.6,259.8,414.7,260.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M397.5,256.4c0,0.4,0.6,1,0.8,1.4l0.9-0.6C398.5,257.1,397.6,257,397.5,256.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M398.3,257.8l-1.3,0.8C398.2,258.6,398.5,258.3,398.3,257.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M404.9,259.7l2.1-1.7l-2.6,1.8L404.9,259.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M392.3,257l0.7-1l-1.2,1.5L392.3,257z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M388.9,257.5c0.5-0.8-0.9-1.2-0.3-1.7c-0.9,0.3-1.7,0.8-2.4,1.5c0.4-0.2,0.9-0.3,1.4-0.2 C388,257.2,388.5,257.3,388.9,257.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M385,258.3c0.4-0.3,0.8-0.6,1.2-0.9C385.7,257.6,385.3,257.9,385,258.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M394.6,258.8c-0.1-0.2-0.3-0.4-0.5-0.6c-0.2-0.2-0.5-0.3-0.7-0.3l0.7,1L394.6,258.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M394.7,258.8h-0.1C394.6,258.8,394.7,258.9,394.7,258.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M400.9,259.2c-0.8,0.7-2.4,1.7-0.6,2.3C400.8,260.7,399.7,260.3,400.9,259.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M395.6,260h1.5c0-0.3-0.4-0.7,0-1L395.6,260z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M394.9,260.5l0.7-0.4H395L394.9,260.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M387.6,259.1c-0.6,0.4-1.4,0.7-2.1,0.7c0.8,0.2,1.7,0.2,2.5,0.2C388.3,259.6,388.5,259,387.6,259.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M390.8,259.1h-0.1C390.7,259.1,390.8,259.3,390.8,259.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M377.6,260.2l0.1,0.2l0-0.2H377.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M388.3,260.2c0.2,0.1,0.5,0,0.8,0c0.2-0.1,0.4-0.2,0.6-0.5c-0.5,0.2-1,0.3-1.5,0.3 C388.1,260.1,388.1,260.2,388.3,260.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M382.8,258.9c0.4,0.2,0.7,0.4,1.1,0.5C383.6,259.1,383,258.6,382.8,258.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M390.4,258.9C390.3,258.6,390.3,258.8,390.4,258.9L390.4,258.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M390.4,258.9c-0.3,0.2-0.5,0.5-0.8,0.7c0.4-0.1,0.7-0.3,1-0.5L390.4,258.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M375.3,267.2c0.1-0.3,0.3-0.6,0.6-0.9s0.6-0.4,0.9-0.5c0.3-0.1,0.7-0.1,1,0c0.3,0.1,0.7,0.2,0.9,0.4 c1.4-0.8,0.4-4.1-1-5.9c0,0.5,0,0.9-1.5,1.5c0.5,0.5,3.4,1.2,2.1,2.1c-2,0.6-1.7-0.3-2.5-0.8c0.9,1.2-2.5,1.9-2.1,3.7l1.8-0.7 C375.6,266.5,374.9,267,375.3,267.2L375.3,267.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M380.7,260.4l0.6-0.1c-0.8-0.3-1.5-0.7-2.2-1.3c-1,0.5-1.2,0.9-1.3,1.2h3L380.7,260.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M383.9,260.1c-0.4,1.1-1.9,1.7-0.9,2.8c1.8-0.2,1.2-1,2.3-1.5c-2.9,0.5,0.8-0.6-1.3-1.1c0.5-0.2,1-0.3,1.5-0.4 c-0.5-0.1-1-0.2-1.5-0.4c0.1,0,0.2,0.2,0,0c-0.2-0.2,0,0,0,0l-0.1,0.4c-0.8-0.2,0-0.3,0.1-0.4v-0.2l-2.8,0.8 C382.1,260.2,383,260.2,383.9,260.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M399.1,264.1C399.1,264.1,399,264,399.1,264.1c-0.1-0.1-0.1-0.2-0.1-0.2C398.8,264,398.7,264.1,399.1,264.1 L399.1,264.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M397.8,263.7c0.2-0.2,0.3-0.6,1-0.6c0.7,0,0,0.5,0.2,0.9c0.4-0.3,1.3-1,0-1.3l-0.2,0.2 c-1.2-0.2-2.9-1.4-2.7-1.5C396.5,262.1,397,263,397.8,263.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M390.8,262.3l-2.4,0.8l1.3,0.8v-0.6C390.8,263.4,390.6,262.7,390.8,262.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M377.3,259.7l0.3-1.2l-1.3,1.7L377.3,259.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M374.2,259.9l0.1-1l-0.8,0.6L374.2,259.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M200.1,216.8c-0.3,0-0.5-0.2-0.8-0.3C199.6,216.7,199.8,216.8,200.1,216.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M204.4,220.2l0.4-0.3C204.5,220,204.3,220.1,204.4,220.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M297.7,250.4c-0.7-1.1-1.4-2.9-1.6-1.8v1.1C296.7,249.7,297.3,250,297.7,250.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M245.2,237.4l0.2,0.4l1.1-0.7L245.2,237.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M242.6,241.2l-1-1.2C241.9,240.5,242.2,240.9,242.6,241.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M169.8,187.1l-3.1-1.9C168.2,186.9,168.6,186.5,169.8,187.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M341.9,258.8c-0.7-0.4-1.4-0.7-2.2-0.9C340.8,258.6,341.5,259.7,341.9,258.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M209,208.9c-0.5,0-0.7,0-0.9,0.2C208.6,209.2,208.9,209.2,209,208.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M337.2,257.6c0.1,0.1,0.3,0.2,0.4,0.3c0.7-0.1,1.4-0.1,2.1,0c-0.3-0.3-0.8-0.5-1.2-0.6 C338.1,257.3,337.6,257.4,337.2,257.6L337.2,257.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M194.6,206.1v0.3C194.6,206.4,194.7,206.2,194.6,206.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M194.5,238.6c-0.1-0.4-0.2-0.7-0.3-1.1C194.2,237.9,194.3,238.3,194.5,238.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M364.7,263.7c-0.1,0.1-0.2,0.1-0.2,0.2c0,0.1-0.1,0.2-0.1,0.3C364.4,264,364.5,263.8,364.7,263.7L364.7,263.7z "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M329.6,263.7C329.7,263.8,329.7,263.7,329.6,263.7L329.6,263.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M362.5,259.8c-0.3-0.2-0.5-0.3-0.8-0.4C362,259.6,362.2,259.7,362.5,259.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M362.4,259.2h0.6C363.1,259.2,362.9,259.1,362.4,259.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M360.6,259.3c0.4,0,0.7,0,1.1,0.2c0,0-0.2-0.2-0.2-0.2C361.6,259.2,361.1,259.3,360.6,259.3L360.6,259.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M204.9,194h-0.2C204,194.4,204.4,194.3,204.9,194z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M274.8,255.6c1.4-0.9,2-0.6,2.5,0l0.3-3.3L274.8,255.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M188.2,206.5c0.3,0.8,0.7,1.6,1.1,2.5c-4-1.7-5.7-4.1-4.9-1.4c1.9-0.5,4.1,1.5,6.2,3.6c0.6,0.5,1.1,1,1.6,1.5 c0.3,0.3,0.7,0.5,1.1,0.6c0.3,0.2,0.7,0.2,1,0.1c0.3-0.1,0.7-0.2,0.9-0.5l0.4,1.3c-0.2-0.3-0.4,0-0.6-0.4c0.7,2.8,2.9-0.8,4.9,1.5 c0.6,0.9,0.9,1.7,0,1.6l2.4,0.7c0.5,0.5,0,0.8-0.5,0.4l2.9,1.9c0.9-0.1,1.8-0.1,2.7,0c0.4,0.9-0.6,0-0.6,0.5l2.1,0.4 c0.1,1.2-1.7,1-2.7,0c-0.6,3.8,1.8,0.2,3.9,4.1l-1.8-0.7c-0.2,2.3,1.4,2.5,2.5,4.8c0-0.8-1.7-4.9,0.5-4.4c0.2,0.4,0.5,0.7,0.9,0.9 c0.4,0.2,0.8,0.3,1.3,0.3c-0.7,1,0.4,1.3,1.7,2l-1,1.3c1.5,0.4,1.9-0.4,3-0.5c1.3,1,0.9,2.3,0.7,3.4c2.1,1.6-0.5-2.7,2.3-1.3 c1.7,1.4,3.8,2.3,6,2.3c1,1.2-0.7,0.7-0.5,1.4l1.8-0.5c0.3,0.2,0,0.5-0.2,0.6c1.2,0,0.9-1.4,2.5-0.9c1.2-1.4,2,4,4.9,3.3 c0.3,0.6-0.7,0.8-0.8,1.4c1.9,0.3,3.9,0.2,5.8-0.2l1.4,1.9c-0.9-1.8,1.5-2.2,3.6-2.5c-0.2-0.6-0.4-1.2-0.6-1.8l2.8,0.3 c0.2,0.4-0.3,0.8-1,1.2c0.2,0,0.4-0.1,0.6-0.1c0.6,0.9-0.2,1.6-1.2,2.1l-0.5-1.3c-1,0.6-2.1,1.3-2.4,2.3c0.3-0.1,0.7-0.1,1,0 c-0.3,0.2-0.5,0.4-0.5,0.5c0,0.2,0.4,0,1-0.2l-0.2,1.9l0.5-0.6l2.8,2.5c3.1-0.6,6.3-2.2,10.3-1.3c-1.4,0.8-1,1.9-1.7,3.4 c-0.4-2-3.2-0.6-5.1-1.7c1,0.6,0.4,1.2,0,1.3h4.1c-0.6,1.2,0.4,1.2,1.1,2.1c0.3-2.5,3.3-0.5,5.1-0.7c-0.2,0.8-0.9,1.5-2.5,0.6 c1.2,2.5,3.6-1.8,4.9,0.5c-0.5-0.2-0.6-0.4-1,0c1.3-0.3,3.5,1.2,2.7,1.7l-0.4-0.2c2.8,1.4,8.7,3.3,9.9,1.4c-0.5,0.9-1,1.7-1.6,2.5 l7.6-5.1c-1.1,1.6-0.8,6.4-3.6,6.5c0.4,0.4,0.9,0.7,1.4,0.8c0.5,0.2,1.1,0.2,1.6,0.1c-0.4-0.4-0.3-2.9,0.4-2.9 c1.1,2.5,0.9,1.5,2.5,3.9c-0.6-0.6,1.2-3.1,2.2-2.5c-0.3,0.3-0.8,2.7-1.3,2.9l3.7-1.7c-0.8,0.2-0.9,2.3-0.5,3.2 c0-0.6,2.5,0.8,3.3,0.8l-1-1c3.1,1.4,4.3-2.8,7.4-1.8c-0.6,0.5-2,3.2-0.4,4c1.2-1.2,5.1-5.8,8.1-6.3l0.3,0.9l2.3-0.4 c-2.8,2.6-5.9,4.8-9.2,6.6c1,1,0,1,1.9,1.5c0.5,0.9-1.3,0.9-1.9,0.8c1.4,0.6,2.8,1.1,4.2,1.6c0.2-1.7,3.7-0.9,3.8-2.3l-5.1,0.6 c0.6-1.2,1.6-2.2,2.8-2.8c1.2-0.6,2.6-0.7,3.9-0.3c0.6,0.9-1.2,2.8-1.3,3.4c0.5-0.5,3.1-0.5,3.3,0l-1.5,0.6c1.6,1,3.2-1.7,4.9,0.4 c0.7,0.3,1.7,2.5,2,1.6c-0.6-3.2-0.2-6.4,1.1-9.4c1.4,1,2.7,2.2,3.9,3.6c0.9,1.7-2.3,3.3-1.6,4.8c0.1-0.5,0.9-0.9,1.2-1 c0.7,0.5-0.6,1.4,1.1,1.4c0.5-1.7,3.2,0.7,1-1.3c1.6-0.2,1.6,0.6,3.5,0.8c-0.4-1.2,2.2-3.5,3.8-3.8c-0.1,0.5,0,0.9,0.3,1.3 c3.1,0.6,4.8,1.5,7.7,2c0.2,0.5,1.6,1.1,0.9,1.8c0.5-0.5,1.2-0.7,1.9-0.8c1.6,1.7-2.1,0-0.9,2c0.2-1,2.5-1.1,3.9-1.7 c-0.3-1.6-3-0.6-4.4,0c0.2-2.1,2.7-4.1,5.9-4.8c2.5-0.3,0.9,1.5,1.4,1.2c4.6,0.7,4.2-3.5,7.9-1.7c1.4,1.4,0,2.7,0.2,3.7 c-2.1,0.4-3-1.1-4.4-1.1l1.7,0.8c-0.4,0.2-0.9,0.4-1.4,0.4c-0.5,0-1,0-1.4-0.2c1.5,0.8,3.2,1.1,4.8,1.1c2.2,0,4.4,0.4,6.6,1 c0.7-0.4,1.8-0.9,1.3-1.4l-1.1,0.2c-1-1.1,2.2-1.4,0.8-2c0.8-0.6,1.6-1,2.6-1.2c0.9-0.2,1.9-0.2,2.8-0.1l0.4,1.6c0-0.5-1.4-1-2-0.5 c0.9-0.7,3.2,2.2,4.2,0.2l-1.5-1.1c1.5-0.8,3.4-2.5,5.2-1.9c-0.8-1.5-0.4,0.2-1.8-1.6c1.1,2.2-4.8,0-2.9,2.3 c-1.3-2.1-2.4-0.9-4.1-2.8c0,0.5,0.6,1-1,0.7c-0.1,0.2-0.2,0.3-0.4,0.4c0.3,0.2,0.6,0.5,0.8,0.8c-0.8,1.1-3.3,1-4.2,1.6 c-0.9-0.3,0.4-0.6,0-1.1l-1.3,0.8c0-1.1-2.4-2-0.2-2.5l-2-0.2c-0.5-0.4-1.2-0.6-1.8-0.7c-0.6-0.1-1.3-0.1-1.9,0.1 c-0.9-0.3-2.5,1.1-1.6,0.3l-3.1,0.5V259c-3-0.4-6.5,1.3-9.7-1.1c-1.3,0.3-2.6,0.2-3.8-0.2l-0.2-1c-1.4,0.2-3.8-1.5-4.5-0.6 c-1-2.8-6.2-1.5-8.4-2.4l-0.3,1.2c-1.7-0.3-3.4-0.3-5.1-0.1v1.1c-1.9,0.6-4.2-1.6-6.8-2.2c0.3-0.4,0.9,0,1.3,0.3 c-2.5-3.3-7.1,0.3-9.4-2.3c-0.3,0.1-0.6,0.1-0.9,0c-0.3-0.1-0.6-0.3-0.8-0.5c0.1,0,0.1,0,0.2,0c-0.1,0-0.2,0-0.3,0l-0.8-0.9 c0.2,0.3,0.4,0.6,0.6,0.8c-0.7-0.1-1.5-0.2-2.3-0.2v-1.3h-0.2c-0.6-0.7-0.8,0.4-0.6,1.4c-0.4,0-0.9,0.2-1.3,0.4 c0-2.1-2.3,0-2.5-2.3c-0.8,0.8-4.3-0.6-5.4,1.3c0-0.3,0-0.5,0.3-0.4c-0.3-0.3-0.7-0.6-1.2-0.7c-0.4-0.1-0.9-0.2-1.4-0.1l0.2-1.6 l-2.5,1.3c-0.9-1.3-1.2-2,0.4-2.7c-3.4,0.7-2.5-0.2-5.5,0.7l0.5-0.9c-0.9-0.3-2.7,0.5-2.9-0.5c-1.2-2.5-9.4-3.8-13.5-7.5 c-0.2,3.1-1.7-2.2-2.8-0.2c0-0.8-0.5-1.4,0.5-1.6c-2.7-0.4-3.2-2.5-5.7-1.5c0-0.8,0.9-0.7,0.9-1.2c-0.3,0-1,0.2-1.1-0.3 c-0.1-0.5,0.6-0.4,1.1-0.5c-2.5-1-3.6,0.8-4.7,2.5c-0.8-1.4-1.5-1.6-3-0.8c-0.2-0.8-0.6-1.8,1-1.3c-0.8-0.5-4.8-3.4-5.6-2 c0-0.5-1.1-0.7-1.4-0.6c-1.2-0.8-2.5-1.5-3.9-2.1l0.4,0.5c-1.7,1.3-1.8-0.4-3.4-1l0.1-0.2c-2.7-3-1.8-0.2-4.3-3.5l-0.4,1.2 c-1.6,2.1-2.2-3-4.5-3.3l0.3,1c-1.5,0-1-4.9-1.8-5.7c0-0.3,0.5,0,0.9,0c-1.8-2.9-1.2,1.1-3.4,0.2c0-1,1.7-1.5,0.4-2.5 c-0.2-1-5.3-0.3-6.1-2.9c0,0.8,0,1.6-1.2,1.4c-1.5-0.8-2.1-4.7-4.5-4c0-0.1-0.1-0.2-0.1-0.3c0-0.1,0-0.2,0.1-0.3 c-1.4-0.3-3.8-1.9-5.1-1.5c0.9-2-1-2.9-2.7-3.6c-1.2-0.4-2.5-1-0.8-1.9l-1.7-1.4h0.5c-0.5-0.9-2.1-1.2-4-1.7c0.2-0.3,0.9,0,1.2,0 c-0.3-1.5-0.2-1.1-5.5-4l2.5,0.7c-0.9-0.5-0.4-0.8,0-1c0.4-0.3,0-0.2,0.2,0c0.3,0.1,0.7,0.1,1,0.2c0.5,0,0.8,0,0.5-0.4 c0.3,0.2,0.6,0.4,0.9,0.6c-0.4-0.7,2.5,0.2,3.9,0.7c1.4,0.5,1.9,0.6,0.6-1.7c0.3-0.4,0.6-0.8,1-1.1c-1.3-0.2-1.6-0.7-1.7-1.3 c0-0.6,0.3-1.1-0.7-1.5c0.8,0,1.6,0.2,2.3,0.7c0.6,0.4,0.8,0.9,0.2,1l-0.3-0.3c0.1,0.4,0.4,0.8,0.7,1.1c0.4,0.3,0.8,0.4,1.3,0.4 c0.8,0.2,1.7,0.2,1.6,1c3.7,0.1,7.4,0.4,11.1,0.9l-0.5-9.5h-8.6l0.7,1.9h-2.2c0,0-0.7-1.4,0.8-1.4c-0.8-1-2.5,0.9-2.5,1.2 c-3-0.9,1.2-2.1,0.3-2.2h-1.2l0.3,0.2c-1,0.7-1.2,1.5-3,1.3c-1.1-0.5-0.5-1.2-0.9-1.3c0,0,0-0.2-0.7,0l-3.9-0.7 c0.6,0.6,1.1,1.2,1.7,1.7c-1.7,0.5-3.7-0.7-1.7,1.4c-1-0.9-2.3-1.6-3.6-2c-1.8-0.7-3.6-1.2-5.5-1.7c-0.4-0.1-0.9-0.2-1.3-0.3h-1.1 H181c-0.8,0-1.5-0.1-2.3-0.3c-0.2,0.5-0.7,0.7-1.3,0.7c-0.3,0-0.7,0-1,0c-0.2,0-0.4,0-0.6,0c-0.3,0-0.5,0.1-0.8,0.3 c0.2,0,0.5,0,0.7,0.1c0.2,0.1,0.4,0.2,0.6,0.4c0.3,0.3,0.1,0.6-0.6,1.3c-1.1-1.3-2.3-0.7-2.5,0.3c-0.3,1,0.2,1.8-1.1,1.7 c0.8,0,1.2,1.1,1.7,2.3s1.5,2.5,2.5,2.2c0.3,1.3-1.7-0.6-2.4,0.2c0.8,1,1.5,2.2,2.2,3.3c1.2,2,2.3,4,3.2,6.1 c0.6,1.1,1.1,2.3,1.8,3.4l1,1.8l0.5,0.8l0.4,0.5c0.4-0.2,0.6-1.2,1.7-0.7l-0.8,3.2c0.6,0.7,2.5-0.5,2.1,1.6c0.2-0.4,0.6-0.9,1-0.5 c1.4,4.1,3,8.1,4.8,12.1c1.4,4.2,3,9.1,1.9,13.5c0.6-1.3,0.8-0.6,1.1,0.3c0-0.6,1.1-0.2,1.7-0.5c-0.3,1.2-0.6,2.5-1.1,3.7 c0.9,0.2,1,1.1,1,1.9c0.1,0.8,0,1.5,0.8,1.8l-0.2-1c0.9,0.7,2,0.3,3.1-0.4s2.2-1.8,3.5-1.7c-1.1-0.9-0.5-2.3,0-3.8 c0.4-0.8,0.4-1.6,0.2-2.5s-0.8-1.5-1.5-2c0.3-0.8,0.9,0.4,1.3-0.1c-1.2-0.5-1.7-1.3-1.7-3.1l0.3,0.1c-0.7-1.8-1.1-3.7-1.3-5.7 c-0.1-2.3-0.5-4.5-1-6.7l-1,0.8c-0.2-0.7-0.2-1.5,0-2.2c-2.2-0.6,1.2,3.3-1.2,2.8c0.9-1.2,0-3.2-0.7-5.1c-0.7-1.9-1.6-3.7-0.6-4.8 c-0.8-1.7-1,1.1-1.8-0.5l0.4-0.8h-1.1c-0.2-0.4-0.2-0.9-0.1-1.4c0.1-0.5,0.4-0.9,0.8-1.2c0,0.3,0.6,0.7,0.7,0.9 c0-1.8-2.5-3.7-2.5-4.3l0.5,1.8l-1.4-1.9c-0.3-0.3-0.5-0.7-0.7-1c-0.4-0.8-1-1.5-1.6-2.2c-0.7-0.7-1.4-1.4-2.2-2l-0.8-0.2 c-1.4-1.2-1.4-1.6-1.3-1.7c0.2-0.2,0.4-0.2-0.6-1.5l0.3,0.2c-1.3-1-1.8-2.3-1-2.5c0.3,0.6,1.2,0.9,2,1.3c0.8,0.3,1.4,0.8,2,1.5 c-0.1-0.5-0.3-0.9-0.6-1.2c-0.6-0.7-1.2-1.4-1.6-2.2l1.7,1.4c-0.6-0.9-1-1.5,0.2-1.4c-0.2,0.3,0.5,0.8,1,1.4c0.6,0.4,1,1,1.2,1.6 c2.1,1.5,2.1,1,2.5,0.8c0.4-0.3,1-0.5,1.9,1.2c0.4-2.5-2.5-1.9-2.2-2.4c-0.5-0.5-0.6-1-0.2-1.3c0.2-0.1,0.5-0.2,0.8-0.3 c0.3,0,0.6,0,0.8,0.1c0.6,0.1,1.1,1.1,1.8,2c0.6,0.9,0.8,1.8,2.8,1.9c-0.4,0-0.4,0.2-0.7,0c1.2,0.8,2.5-0.7,4.1,0.5 c1-1.5,2.1,0.2,2.4-1.8c-1,0.1-2.1,0.3-3.1,0.3c1.8-0.4,3.5-2.5,6.4-1.5c-0.5,0.5-1,1-1.7,1.2c0.8,0.6,1.6-0.4,2.5,0.2 c-0.2,2-3.8,0.5-5.8,1.9c0.9,0.9,3.7-1.3,2.7,0.8c1.4-2.7,3.5,0.4,5.8-1.9v1.2c0.5-0.4,1.1-0.7,1.8-0.8l-1.1,1.7 c1.8-1.4,3.8,0.9,5.6,0c-3.9,0.5-1-1.3-2.7-2.1c0.8-0.5,1.7-0.6,2.5-0.5l-0.4-8.8c-1.5-0.7-1.4-3.2-5.1-2.9 c0.7-0.2,2.5,0.8,1.4,1.3c-1-0.2-2-0.7-2.7-1.4c-3.3,0.2,0.5,1.2-0.9,2c-1.1-1.5-1.6,0.6-3.1,1v-1.2c-0.5-0.1-1-0.2-1.5-0.2 c-0.3,0-0.7,0-1,0.1c-0.2,0.1-0.3,0.2-0.5,0.3c-0.1,0.1-0.2,0.3-0.3,0.5c-0.2,0.6-0.3,1.2-2.7,0.7c0.5-0.6,1-1.1,1.6-1.7l-2.5,0.4 v-1.4c-2.3,0.8-4.7,0.9-7,0.2c1.4,0.9,1.4,2.3-0.8,2.2c-2.4-0.8-0.3-1.2-3.6-1.1c-0.2-0.8-0.2-1.7,2.5-0.5c-0.2-0.4,0-0.8,0-1.2 c-1.3-0.4-2.6-0.6-4-0.5c-1.2,0-1.9,0.3-2.5,0.3c0.6,0,1.2,0.1,1.8,0.3c-0.9,0.5-1.8,1.1-2.7,1.8c-1.4-0.4-1.4-0.8-1.3-1.2 c-0.8,0.2-0.7,0.7-1.9,0.8c-1.2-1-3-2-1.4-2.5c-1.2,0.4-2.3,0.8-3.3,1.2c-1.6-0.4-3.2-0.9-4.8-1.4c-1.3-0.2-2.7,0-3.9,0.7 c1.9,1.4,3.5,3.1,4.9,5.1c0.7,0.4,1.3,0.9,1.9,1.4c1.8,2.5,2.1,4.8,6.9,8.2c-0.4,0.5-0.7,1.1-0.9,1.7c1.4,1.3,1.6,0.7,2.1,0.3 s1.2-0.5,3.3,1.4c3.1,2.5-1,1.2-0.7,2.3c1.3,0.7,3.1,1.5,4.6,2.5c1.5,0.8,2.7,2.1,3.4,3.7C190.1,208.5,189.1,207.5,188.2,206.5 L188.2,206.5z M211.3,224.5c-0.6,0-1.9,0-1.8-0.8C210.9,223,210.9,223.7,211.3,224.5z M247.7,241.1c-0.5,0.2-0.9-0.2-1.3-0.9 C246.9,240.4,247.4,240.7,247.7,241.1z M354.2,259.9C353.1,259.4,353.4,259.6,354.2,259.9L354.2,259.9z M356.4,260.5 c0,0,0.1-0.1,0.1-0.1c0,0,0.1-0.1,0.1-0.1c0,0,0-0.1,0-0.1c0,0,0-0.1,0-0.1c-0.2,0.3-0.7,0.3-1.3,0.2 C355.5,260.5,355.7,260.8,356.4,260.5z M198.2,185.4l0.4,0.4C197.6,186,197.8,185.7,198.2,185.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M242.9,240.8c-0.1-0.2-0.1-0.5,0-0.7C242.7,240.2,242.6,240.4,242.9,240.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M170.3,187.4c-0.2-0.1-0.3-0.2-0.5-0.2L170.3,187.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M319.7,266.9c-0.3-0.2-0.6-0.5-0.8-0.8C318.8,266.4,319,266.7,319.7,266.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M368.5,258.8l-1.4,0.3c0.5,0,1,0.1,1.3,0.4C368.3,259.3,368,258.9,368.5,258.8L368.5,258.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M381.3,266.2c0.2-0.2,0.5,0,0.7-0.2v-0.6C380.9,265.6,380.3,266,381.3,266.2L381.3,266.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M369.8,262.9c0,1,1,0.7,2.1,0.5h-0.2C372,262,370.9,262.4,369.8,262.9L369.8,262.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M372.1,263.4c0.3-0.1,0.6-0.1,0.9,0C373.1,262.8,372.6,263.2,372.1,263.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M359.3,260c0.5,0.3,0.4-1.3,0.6-0.9C360.5,257.8,356.7,260.6,359.3,260z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M370.6,266.3l-0.4-1.3l-0.6,1L370.6,266.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M362.4,265.2l1.7,0.4c0-0.2,0.2-0.3,0.5-0.4C363.5,265.2,362.4,264.8,362.4,265.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M364.5,265.2c0.4,0.1,0.9,0,1.3-0.2C365.4,265,365,265.1,364.5,265.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M368.3,266.7l-0.5-0.3l-1.2-0.1L368.3,266.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M344.7,263.9l-1.8,0.2c-0.2,0.4,0.2,0.7,0.9,0.6S345,264.4,344.7,263.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M349.9,267.8c-0.5-0.3-0.5-0.6-0.7-1l-0.2,1.6L349.9,267.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M344.6,267.8c-0.2,0.4-2.8,1-0.4,1.1C344.4,268.5,346.2,268.3,344.6,267.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M317.7,262.2l0.4,0.1l0.4-2.5L317.7,262.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M292.4,262.6c2,1.2,1-1.4,2.5,0c0.7-0.4-1.4-1-0.7-1.4C292.9,261.3,292.3,260.7,292.4,262.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M294.3,261.1c0.3-0.1,0.5-0.1,0.8-0.2C294.8,260.9,294.5,261,294.3,261.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M193.5,242.8c-0.2,0.3-0.3,0.6-0.6,0.9c0.3-0.2,0.6-0.3,0.9-0.6L193.5,242.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M195.2,244.8h-1.7c0.5,0.3,0.9,0.5,1.4,0.8C195,245.3,195,244.9,195.2,244.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M212.8,229.5l0.3-0.3c0-0.5-0.2-0.7-0.8-1.1L212.8,229.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M197.7,216.9l0.3,0.3l0.5-1.6L197.7,216.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M178.8,201.3c0.9,1,1.8,1.9,2.8,2.7C179.2,202.1,181,200.9,178.8,201.3z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrow1);
export default __webpack_public_path__ + "static/media/arrow1.1de73ad4560d0aae1b7eda8c37d0555d.svg";
export { ForwardRef as ReactComponent };